import { TextureLoader } from '../../../../src/js/three.module.js';
import { AdditionalObjectPlane } from "./additional-object-plane.js";
import { getTextureLoader } from '../../../utils/loaders/loader-manager.js';


//function canvasFillLinebrakedText( canvas, text ) {

function printAtWordWrap(context, text, x, y, lineHeight, fitWidth) {
    fitWidth = fitWidth || 0;
    
    if (!text) return;

    if (fitWidth <= 0) {
        text.split('\n').forEach((line, i) => {
            context.fillText(line, x, y + (lineHeight * i));
        });
        return;
    }

    var lines = text.split('\n');
    var currentLine = 0;

    lines.forEach(textLine => {
        var words = textLine.split(' ');
        var idx = 1;

        while (words.length > 0 && idx <= words.length) {
            var str = words.slice(0, idx).join(' ');
            var w = context.measureText(str).width;

            if (w > fitWidth) {
                if (idx == 1) {
                    idx = 2;
                }
                context.fillText(words.slice(0, idx - 1).join(' '), x, y + (lineHeight * currentLine));
                currentLine++;
                words = words.splice(idx - 1);
                idx = 1;
            } else {
                idx++;
            }
        }

        if (idx > 0) {
            context.fillText(words.join(' '), x, y + (lineHeight * currentLine));
            currentLine++;
        }
    });
}


// Helper function to generate text image source using canvas
export function buildTextSrc( text, ratio, opts = {}, canvas = document.createElement("canvas") ) {

    let { height, font_size_px, font_name, text_color } = {
        height:       256,
        font_size_px: 96,
        font_name:    "Helvetica",
        text_color:   "white",
        ...opts
    };

    canvas.height = height;
    canvas.width = Math.round( height * ratio );

    let context = canvas.getContext("2d");

    if (!context) throw new Error("Could not get canvas context!");
    
    context.clearRect( 0, 0, canvas.width, canvas.height );
    //context.font = font_size_px + "px Helvetica";
    context.font = `${ font_size_px }px ${ font_name }`;
    context.fillStyle    = text_color;

    context.textAlign    = "left";
    context.textBaseline = "top";
    printAtWordWrap(context, text, 0, 0, font_size_px, canvas.width );

    //context.fillText( text, Math.round( canvas.width / 2 ), 0 );
    
    return canvas.toDataURL("image/png");
}

function buildTextureUrl( opts ) {

    let { text, width, height, text_height, font_size_px } = opts;

    let text_color = opts.text_color || opts.color;

    return buildTextSrc( text, width / height, { height: text_height, font_size_px, text_color });
}

/**
 * Implements a text element based on plane element for placing text in 3D scene
 */
export class AdditionalObjectText extends AdditionalObjectPlane {

    canvas;

    constructor( text = "Text", width = 1, height = 0.5, text_height = 256, font_size_px = 96, text_color = "white" ) {

        const canvas = document.createElement("canvas");

        const texture_img_url = buildTextureUrl({ text, width, height, text_height, font_size_px, text_color });

        // Create material with text texture
        const material = {
            transparent: true,
            texture_img_url
        };
        
        // Initialize base plane with dimensions and material
        super( width, height, material, { texture_img_url });

        this.canvas = canvas;
        
        // Set type and store text content
        this.type = "text";

        this.opts.text = text;
        this.opts.text_height = text_height;
        this.opts.font_size_px = font_size_px;
        this.opts.color = text_color;
    
        
        // Refresh the object hash
        this.updateTextTexture();
        this.refreshHash();
    }

    /**
     * Updates the text content and regenerates texture
     */
    setText( text = this.opts.text, text_height = this.opts.text_height, font_size_px = this.opts.font_size_px, text_color = this.opts.color ) {
        
        this.opts.text         = text;
        this.opts.text_height  = text_height  || 256;
        this.opts.font_size_px = font_size_px || 96;
        this.opts.color        = text_color   || "white";

        this.updateTextTexture();
        this.refreshHash();
    }

    /**
     * Regenerates texture based on current text and dimensions
     */
    updateTextTexture() {
        this.setTextureImageUrl( buildTextureUrl( this.opts ) );
        this.mesh.castShadow = false;

        let materials = this.getMeshMaterialArray();

        if (materials?.length == 6) {
            materials.forEach(( material, i ) => {
                material.visible = (i == 4);
            });
        } else {
            materials.forEach(( material, i ) => {
                material.visible = true;
            });
        }
    }

    updateMeshMaterial() {
        this.updateTextTexture();
    }

    /**
     * Creates text object from options object
     */
    static fromOpts( opts ) {

        const obj = new AdditionalObjectText(
            opts.text,
            opts.width,
            opts.height,
            opts.text_height,
            opts.font_size_px,
            opts.color
        );

        if (opts.uuid) {
            obj.changeUuid( opts.uuid );
        }

        return obj;
    }

    /**
     * Creates object from saved data
     */
    static loadSave( save ) {
        // Create base object
        const obj = new AdditionalObjectText(
            save.text,
            save.width,
            save.height,
            save.text_height,
            save.font_size_px,
            save.color,
        );

        return AdditionalObjectText.applySave( save, obj );
    }

    static applySave( save, obj ) {
        return AdditionalObjectPlane.applySave( save, obj );
    }

    /**
     * Generate unique hash for this object type
     */
    static genHash( obj ) {
        let { text,  text_height, font_size_px } = obj.opts;
        return obj.type + 
            "-" + font_size_px +
            "-" + text_height +
            "-" + text;
    }

    genHash() {
        return AdditionalObjectText.genHash( this );
    }
}